/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */

import Client from "./clients/rest";

export default {
    getTotalCalls(businessId, from, to) {
        return Client.get(`business/${businessId}/statistics/totalcalls`, {
            params: {
                from,
                to,
            },
        });
    },

    getWhatsappClicks(businessId, from, to) {
        return Client.get(`business/${businessId}/statistics/whatsapp`, {
            params: {
                from,
                to,
            },
        });
    },

    whatsappDetails(businessId, payload) {
        return Client.post(`business/${businessId}/get-whatsapp-details`, payload);
    },

    getMonthlyStats(businessId, from, to) {
        return Client.get(`business/${businessId}/statistics/monthly`, {
            params: {
                from,
                to
            },
        });
    },

    getEventGroupsStats(businessId, from, to) {
        return Client.get(`business/${businessId}/statistics/event-groups`, {
            params: {
                from,
                to
            },
        });
    },

    getInterestedByPlatform(businessId, from, to) {
        return Client.get(
            `business/${businessId}/statistics/interested-by-platform`,
            {
                params: {
                    from,
                    to,
                },
            }
        );
    },


   getWhatsappStatus(business_id) {
       return Client.get(`business/${business_id}/get-whatsapp-toggle-status`);
   },

    updateWhatsappStatus(business_id, showWhatsappClicks, showSentMessagesAmount) {
        return Client.put(`business/${business_id}/update-whatsapp-toggle-status?showWhatsappClicks=${showWhatsappClicks}&showSentMessagesAmount=${showSentMessagesAmount}`);
   }


};
